module.exports = __webpack_public_path__ + "static/media/logo_crop.32070c77.png";